<template>
  <modal name="ContactsVerify" :width="800" height="auto" :scrollable="false" :adaptive="false" @closed="modalHide(false)">
    <div data-modal="contact" class="panel mb-0">
      <div class="panel-hdr">
          <div class="w-100">
              <div class="row">
                  <div class="col-lg-12">
                      <h1 class="subheader-title mb-lg-0">
                          <i class="subheader-icon fal fa-window"></i> Подтверждение контакта
                      </h1>
                      <button type="button" class="close" @click="modalHide(false)">
                          <i class="fal fa-times"></i>
                      </button>
                  </div>
              </div>
          </div>
      </div>
      <div class="panel-container show">
        <div class="panel-content">
          <form data-form="verify" @submit.prevent="contactVerify">
            <div class="form-group">
              <label class="form-label">Код подтверждения</label>
              <input type="text" data-input="code" class="form-control" v-mask="'9999'" v-bind:class="{ 'is-invalid': 'code' in errors}" v-on:focus="$delete(errors, 'code')" v-model="code" v-focus>
              <div class="invalid-feedback" v-if="'code' in errors">{{ errors['code'] }}</div>
            </div>
            <div class="panel-tag mb-4">
              Мы отправили код подтверждения на почтовый ящик {{ contact.value }}, введите его в поле выше для сохранения контакта.<br>
              <br>
              Код должен придти в течение нескольких минут, если по истечении данного времени письма нет, проверьте раздел "спам" почтового клиента, если письма в нём нет, то воспользуйтесь другим почтовым сервисом.
            </div>
            <button data-button="verify" class="btn btn-success mr-2">Продолжить</button>
            <span class="btn btn-info mr-2 disabled" v-if="limitSend" v-tooltip="{content: 'Отправка кода проверки возможна раз в 3 минуты', placement: 'top'}">Отправить повторно</span>
            <a href="#" class="btn btn-info mr-2" @click="sendCode" v-if="!limitSend">Отправить повторно</a>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'ContactsVerify',
    props: ['contact'],
    data() {
      return {
        // Ошибки
        errors: {},
        // Код подтверждения
        code: '',
        // Ограничение отправки кода
        limitSend: false
      }
    },
    methods: {
      // Проверка кода
      contactVerify ()
      {
        // Отправка запроса к API
        this.$axios.post(process.env.VUE_APP_API_URL+'/v1/contacts/'+this.contact.id+'/verify', {code: this.code}).then(response => 
        {
          if(response.data.status == 'success')
          {
            this.modalHide(true);
          }
        }).catch(error => {
          // Собираем ошибки
          this.errors = {};
          $.each(error.response.data.errors, function(index, value) 
          {
            this.$set(this.errors, index, value[0])
          }.bind(this));
        });
      },
      // Отправка кода
      sendCode ()
      {
        // Отправка запроса к API
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/contacts/'+this.contact.id+'/code').then(response => 
        {
          if(response.data.status == 'success')
          {
            this.limitSend = true;

            setTimeout(function(){ this.limitSend = false }.bind(this), 180000);
          }
        }).catch(error => {
          // Собираем ошибки
          this.errors = {};
          $.each(error.response.data.errors, function(index, value) 
          {
            this.$set(this.errors, index, value[0])
          }.bind(this));
        });

        return false;
      },
      // Показ модального окна
      modalShow() {
          this.$modal.show('ContactsVerify');
      },
      // Скрытие модального окна
      modalHide(contactsReload = false) {
          this.$emit('close', contactsReload);
      }
    },
    // Подгрузка данных
    mounted () 
    {
      this.modalShow();
      this.sendCode();
    },
  }
</script>